import { buildMitraFilterParams } from '@/constants/mitraFilters';

const FILTER_KEYS = ['status', 'approval_step', 'course_type'];

export default {
  computed: {
    activeFiltersCount() {
      return FILTER_KEYS.filter((key) => Boolean(this.filters?.[key])).length;
    },
    approvalStepLabel() {
      const option = (this.approvalStepOptions || []).find((item) => item.value === this.filters.approval_step);
      return option?.label || this.filters.approval_step;
    },
    courseTypeLabel() {
      const option = (this.courseTypeOptions || []).find((item) => item.value === this.filters.course_type);
      return option?.label || this.filters.course_type;
    },
    statusFilterLabel() {
      const option = (this.statusOptions || []).find((item) => item.value === this.filters.status);
      return option?.label || this.filters.status;
    }
  },
  methods: {
    showFilterModal() {
      this.$bvModal.show(this.filterModalId);
    },
    applyCourseListFilterParams(params = {}) {
      return Object.assign(
        params,
        buildMitraFilterParams(this.filters, {
          statusKey: this.statusQueryKey || 'tna_status'
        })
      );
    },
    applyFilters(payload = {}) {
      this.filters = {
        ...this.filters,
        status: payload.status || null,
        approval_step: payload.approval_step || null,
        course_type: payload.course_type || null
      };
      this.reloadCoursesFromFirstPage();
    },
    resetFilters() {
      this.filters = {
        ...this.filters,
        status: null,
        approval_step: null,
        course_type: null
      };
      this.reloadCoursesFromFirstPage();
    },
    clearSingleFilter(filterKey) {
      if (this.filters[filterKey] === undefined) return;
      this.filters[filterKey] = null;
      this.reloadCoursesFromFirstPage();
    },
    reloadCoursesFromFirstPage() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
        return;
      }
      this.fetchCourses();
    },
    clearAllFilters() {
      this.resetFilters();
    }
  }
};
